/** The Kokoro worker, on its own so tests (which cannot load a worker) mock this one line. */
export const createKokoroWorker = (): Worker => new Worker(new URL("./kokoro.worker.ts", import.meta.url));
